<!-- resources/js/views/StepList.vue -->
<template>
    <div class="p-4">
        <h2 class="text-2xl font-serif font-bold text-[#7b0f14] mb-4">
            Liste des étapes
        </h2>
        <router-link
               v-for="step in steps"
               :key="step.id"
               :to="isUnlocked(step.id) ? `/step/${step.id}` : '#'"
              tag="li"
               :class="['block flex items-center justify-between mb-2 p-3 bg-white rounded-lg shadow transition',
                 isUnlocked(step.id)
                   ? 'cursor-pointer hover:bg-gray-100 active:scale-98'
                   : 'cursor-not-allowed opacity-50'
               ]">
                <!-- Étape déverrouillée -->
                <template v-if="isUnlocked(step.id)">
                    <span  class="text-lg font-medium text-[#800000]">
                        Étape {{ step.id }} : {{ step.title }}
                    </span>
                </template>

                <!-- Étape verrouillée -->
                <template v-else>
                    <div class="flex items-center text-gray-400">
                        <!-- Icône cadenas -->
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 mr-2"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M5 8a5 5 0 1110 0v2h1a2 2 0 012 2v6a2 2 0 01-2
                   2H4a2 2 0 01-2-2v-6a2 2 0 012-2h1V8zm2
                   2V8a3 3 0 016 0v2H7z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <span class="text-lg">Étape {{ step.id }} : Verrouillée</span>
                    </div>
                </template>
        </router-link>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

// état local
const steps = ref([])
const unlockedStep = ref(0)

// récupération des étapes et de la progression
onMounted(async () => {

    const { data } = await axios.get('/api/steps')
    steps.value = data

    // lecture du dernier pas débloqué (nombre entier)
    const stored = localStorage.getItem('unlockedStep')
    unlockedStep.value = stored ? parseInt(stored, 10) : 0
})

// logique de déblocage : on autorise jusqu'à unlockedStep ou step 1
const isUnlocked = (id) => {
    return id <= unlockedStep.value || id === 1
}
</script>

<style scoped>
/* Légère animation au clic */
.active\:scale-98:active {
  transform: scale(0.98);
}
/*
 Opacité 70% pour les étape avant celle active
 */

</style>
